import { Component, OnInit } from '@angular/core';
import { UserService } from './../../shared/user.service';
import { Router } from '@angular/router';
import { User } from '../../shared/user.model';
// Service
 import { DynamicScriptLoaderService } from '../../shared/DynamicScriptLoaderService';

@Component({
  selector: 'app-dashboard-menu-admin',
  templateUrl: './dashboard-menu-admin.component.html',
  styleUrls: ['./dashboard-menu-admin.component.css']
})
export class DashboardMenuAdminComponent implements OnInit {

  userDetails = {
    fullName: ''
  };

  constructor(private userService: UserService, private router: Router, private dynamicScriptLoaderService: DynamicScriptLoaderService) { }

  ngOnInit() {
    // this.loadScripts();
    this.userService.getUserProfile().subscribe(
      res => {
        this.userDetails = res['user'];
        this.userDetails.fullName = res['user'].fullName;
      },
      err => {
        console.log(err);
      }
    );

  //   (async () => {
  //     // Do something before delay
  //     console.log('before delay')

  //     await this.delay(5000);

  //     // Do something after
  //     console.log('after delay');
  //       // You can load multiple scripts by just providing the key as argument into load method of the service
  //   this.dynamicScriptLoaderService.load('functions-js').then(data => {
  //     // Script Loaded Successfully
  //   }).catch(error => console.log(error));
  // })();


  }

//   delay(ms: number) {
//     return new Promise( resolve => setTimeout(resolve, ms) );
// }

  // private loadScripts() {
  //   // You can load multiple scripts by just providing the key as argument into load method of the service
  //   this.dynamicScriptLoader.load('functions-js', 'header-css').then(data => {
  //     // Script Loaded Successfully
  //   }).catch(error => console.log(error));
  // }

  onLogout() {
    this.userService.deleteToken();
    this.router.navigate(['/login']);
  }


}
